import * as React from 'react';
import { AgentType } from './types';
import { LoadingSpinnerIcon } from '../../../assets/images/askAiIcons';

interface LoadingIndicatorProps {
  classes: any;
  selectedAgent: AgentType;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ classes, selectedAgent }) => {
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'flex-start',
      padding: '8px 16px',
      gap: '8px'
    }}>
      <div className={classes.compactLoadingAnimation}>
        <LoadingSpinnerIcon />
      </div>
      <span className={classes.compactLoadingText}>
        {selectedAgent === AgentType.BI ? 'Processing...' : 'Thinking...'}
      </span>
    </div>
  );
};

export default LoadingIndicator; 